import { onDestroy, onMount } from "@/modules/_";
import gsap from "@lib/gsap";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const icon = element.querySelector("svg");
  onMount(() => {
    element.addEventListener("mouseenter", animateOut);
  });

  onDestroy(() => {
    element.removeEventListener("mouseenter", animateOut);
  });

  function animateOut() {
    gsap.to(icon?.children as HTMLCollectionOf<HTMLElement>, {
      opacity: 0,
      duration: 0.001,
      stagger: {
        amount: 0.4,
        from: "random",
      },
      onComplete: animateIn,
    });
  }

  function animateIn() {
    gsap.to(icon?.children as HTMLCollectionOf<HTMLElement>, {
      opacity: 1,
      duration: 0.001,
      stagger: {
        amount: 0.3,
        from: "random",
      },
    });
  }
}
